import { useMemo } from 'react';
import { useBoundaryTerritoryDetailsSelector } from '../../../../store/boundaryTerritoryDetails/boundaryTerritoryDetails.selectors';

export const useBoundaryDetailsMarkersCount = (boundaryTerritoryGroupId: number, boundaryIds: number[]) => {
  const boundaryTerritoryDetails = useBoundaryTerritoryDetailsSelector();

  const relevantBoundaryDetails = boundaryTerritoryDetails.get(boundaryTerritoryGroupId);

  const markersCount = useMemo(() => {
    if (!relevantBoundaryDetails) {
      return 0;
    }

    let markersSum = 0;

    for (const boundaryId of boundaryIds) {
      if (relevantBoundaryDetails.counts[boundaryId] !== undefined) {
        markersSum += relevantBoundaryDetails.counts[boundaryId] ?? 0;
      }
    }

    return markersSum;
  }, [relevantBoundaryDetails, boundaryIds]);

  return {
    markersCount,
  };
};
